import React from 'react'

import {
  ClockDefault,
  Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

function IconComponent() {
  return <ClockDefault width="24" height="24" />
}

function ClockIcon() {
  return (
    <Icon
      color="dark"
      notSpaced
      size="tiny"
      svgComponent={IconComponent}
      className="wayfinder__action-icon-svg"
    />
  )
}

export default ClockIcon
